"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchInferredUserRole = fetchInferredUserRole;

var _immutable = _interopRequireDefault(require("immutable"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var IRIS_URL = 'iris-read/v1/app?hubUserField=inferredRole';

function fetchInferredUserRole() {
  return _apiClient.default.get(IRIS_URL).then(_immutable.default.fromJS).catch(function () {
    return _immutable.default.Map();
  });
}